export default {
  keyboardShortcuts: 'Keyboard shortcuts',
  siteWideShortcuts: 'Site-wide shortcuts',
  loading: 'Loading',
}
